import React, { useEffect, useState } from 'react';
import './MarsPage.css';
// import MarketResearchLogo from '../assets/chatg.png';
import {useNavigate} from 'react-router-dom';
// import MarsData from '../assets/Group 351-mars.png';
import MARSLogo from '../assets/MARS_logo-removebg-preview.png'; // Assuming you have a logo image
const MarsPage = () => {
  const [isVisible, setIsVisible] = useState({
    features: false,
    benefits: false,
    cta: false
  });
const navigate = useNavigate();
const handleNavigate = (path) => {
  navigate(path);
  window.scrollTo(0,0);
}

  // Intersection Observer for animations on scroll
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const featureSection = document.querySelector('.mars-features-section');
    const benefitSection = document.querySelector('.mars-benefits-section');
    const ctaSection = document.querySelector('.mars-cta-section');

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target === featureSection) {
            setIsVisible(prev => ({ ...prev, features: true }));
          } else if (entry.target === benefitSection) {
            setIsVisible(prev => ({ ...prev, benefits: true }));
          } else if (entry.target === ctaSection) {
            setIsVisible(prev => ({ ...prev, cta: true }));
          }
        }
      });
    }, observerOptions);

    if (featureSection) sectionObserver.observe(featureSection);
    if (benefitSection) sectionObserver.observe(benefitSection);
    if (ctaSection) sectionObserver.observe(ctaSection);

    return () => {
      if (featureSection) sectionObserver.unobserve(featureSection);
      if (benefitSection) sectionObserver.unobserve(benefitSection);
      if (ctaSection) sectionObserver.unobserve(ctaSection);
    };
  }, []);

  return (
    <div className="mars-page">
      {/* Hero Section */}
      <section className="mars-hero-section">
        <div className="mars-hero-content">
          <h1 className="mars-hero-title">
            <img
                className="mars-hero-logo"
                src={MARSLogo}
                alt="MARS Logo"
                />
            
          </h1>
          <span className="mars-title-accent"></span>
          <h2 className="mars-hero-subtitle">Understand the Market. Outpace the Competition. Make Smarter Business Decisions.</h2>
          <h3 className="mars-hero-description">
            Are you…
            <ul className="mars-bullet-list">
              <li>A business or entrepreneur entering a new market or launching a new product?</li>
              <li>An investor evaluating market potential before funding a venture?</li>
              <li>A marketing team looking for deeper consumer insights to shape campaigns?</li>
              <li>A consultant or analyst using data to guide clients or support further studies?</li>
            </ul>
            If so, MARS is built for you.
          </h3>
        </div>
        
        <div className="mars-square-image-frame">
          {/* <img src={MarsData} alt="MARS Data" /> */}
        </div>
        <div className="mars-hero-image-container">
          {/* <div className="mars-image-frame">
            <img src={MarketResearchLogo} alt="MARS Logo" />
          </div> */}
        </div>
        <div className="mars-accent-shape-top-right"></div>
      </section>

      {/* What is MARS Section */}
      <section className={`mars-features-section ${isVisible.features ? 'fade-in-section' : ''}`}>
        <div className="mars-section-divider">
          <h2 className="mars-section-title">What is MARS?</h2>
        </div>
        
        <div className="mars-intro-content">
          <p className="mars-intro-text">
            MARS is our market research product designed to meet the diverse needs of professionals across various fields. MARS excels in three areas:
          </p>
        </div>

        {/* MARS Key Features */}
        <div className="mars-key-features">
          <div className="mars-feature-card" style={{transitionDelay: '0.1s'}}>
            <div className="mars-feature-header">
              <div className="mars-feature-number">1</div>
              <h3 className="mars-feature-title">Data Collection</h3>
            </div>
            <p className="mars-feature-description">
              MARS gathers raw data from various sources, including:
            </p>
            <ul className="mars-feature-list">
              <li>Quantitative data: Statistics, market size, and growth rates</li>
              <li>Qualitative data: Websites, news, and comments</li>
            </ul>
          </div>

          <div className="mars-feature-card" style={{transitionDelay: '0.3s'}}>
            <div className="mars-feature-header">
              <div className="mars-feature-number">2</div>
              <h3 className="mars-feature-title">Market Segmentation</h3>
            </div>
            <p className="mars-feature-description">
              MARS provides market segmentation to highlight opportunities and challenges based on:
            </p>
            <ul className="mars-feature-list">
              <li>Demographics</li>
              <li>Geography</li>
              <li>Product types</li>
            </ul>
          </div>

          <div className="mars-feature-card" style={{transitionDelay: '0.5s'}}>
            <div className="mars-feature-header">
              <div className="mars-feature-number">3</div>
              <h3 className="mars-feature-title">Competitive Analysis</h3>
            </div>
            <p className="mars-feature-description">
              MARS evaluates key players in the market to assess their:
            </p>
            <ul className="mars-feature-list">
              <li>Strategies</li>
              <li>Strengths</li>
              <li>Weaknesses</li>
            </ul>
          </div>
        </div>
      </section>
      
      {/* MARS Benefits Section */}
      <section className={`mars-benefits-section ${isVisible.benefits ? 'fade-in-section' : ''}`}>
        <div className="mars-section-divider">
          <h2 className="mars-section-title">MARS Benefits</h2>
        </div>
        
        <div className="mars-benefits-container">
          <p className="mars-benefits-intro">
            Depending on the industry and purpose, MARS offers a range of features designed to meet various needs:
          </p>
          
          <div className="mars-benefits-grid">
            <div className="mars-benefit-item" style={{transitionDelay: '0.1s'}}>
              <div className="mars-benefit-icon">
                <div className="mars-red-square">
                  <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2v-4H8v-2h4V7h2v4h4v2h-4v4z"/>
                  </svg>
                </div>
              </div>
              <h3 className="mars-benefit-title">Customisation</h3>
              <p className="mars-benefit-description">
                Tailored to specific industries, regions, or niches, to ensure relevance and precision.
              </p>
            </div>

            <div className="mars-benefit-item" style={{transitionDelay: '0.2s'}}>
              <div className="mars-benefit-icon">
                <div className="mars-red-square">
                  <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
              </div>
              <h3 className="mars-benefit-title">Evidence-Based Confidence</h3>
              <p className="mars-benefit-description">
                Combines primary and secondary research to reduce speculation and provide reliable conclusions.
              </p>
            </div>

            <div className="mars-benefit-item" style={{transitionDelay: '0.3s'}}>
              <div className="mars-benefit-icon">
                <div className="mars-red-square">
                  <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
              </div>
              <h3 className="mars-benefit-title">Time-Saving</h3>
              <p className="mars-benefit-description">
                Condenses vast amounts of data into a digestible format, saving clients from extensive research.
              </p>
            </div>

            <div className="mars-benefit-item" style={{transitionDelay: '0.4s'}}>
              <div className="mars-benefit-icon">
                <div className="mars-red-square">
                  <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"/>
                  </svg>
                </div>
              </div>
              <h3 className="mars-benefit-title">Strategic Edge</h3>
              <p className="mars-benefit-description">
                Highlights untapped opportunities or risks that competitors might overlook.
              </p>
            </div>

            <div className="mars-benefit-item" style={{transitionDelay: '0.5s'}}>
              <div className="mars-benefit-icon">
                <div className="mars-red-square">
                  <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                    <path d="M3 16L8 11 13 14 21 6" stroke="#fff" stroke-width="2" fill="none"/>
                  </svg>
                </div>
              </div>
              <h3 className="mars-benefit-title">Visual Appeal</h3>
              <p className="mars-benefit-description">
                Includes charts, graphs, and infographics to make complex data accessible and engaging.
              </p>
            </div>
          </div>
          
        </div>
      </section>

      {/* Call to Action Section */}
      <section className={`mars-cta-section ${isVisible.cta ? 'fade-in-section' : ''}`}>
        <div className="mars-cta-content">
          <h2 className="mars-cta-title">Discover how this strategic tool can provide clarity and insights necessary for success in your business decisions.</h2>
          <p className="mars-cta-subtitle">Here are a few success stories that highlight the impact of MARS on our clients' businesses:</p>
          <div className="mars-cta-button-container">
            <button className="mars-cta-button" onClick={() => handleNavigate('/contactus')}>
              Contact Us
              <span className="mars-button-ripple"></span>
            </button>
          </div>
        </div>
        <div className="mars-accent-shape bottom-right"></div>
      </section>
    </div>
  );
};

export default MarsPage;